
import axios from 'axios'
import UserBus, { User } from '@/utils/buses/UserBus'

interface LoginResponse {
  token: string
}

export const login = async (email: string, password: string): Promise<User> => {
  const res = await axios.post<LoginResponse>('/auth/login', {
    email,
    password
  })

  // store token
  UserBus.storeToken(res.data.token)
  const user = UserBus.user

  return user!
}

export const logout = () => {
  UserBus.removeToken()
}
